import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Sends an old admin address to its new home, in the same language. The query
 * string follows unless the target sets its own, so a shared link keeps its
 * filters (period, language).
 */
export function AdminRedirect({ to }: { to: string }) {
  const { lang = "fr" } = useParams<{ lang: string }>();
  const { search } = useLocation();
  const target = to.includes("?") ? to : `${to}${search}`;
  return <Navigate to={`/${lang}/admin/${target}`} replace />;
}
